export const ExternalIdProperty = 'Entity-Id';
